// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.multifamily.disclaimer.RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create,
  RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete,
  RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AddMultifamilyFeeDisclaimerRequestDto,
  ListingAlias,
  UpdateMultifamilyFeeDisclaimerRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface DeleteParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Args {
  postData: AddMultifamilyFeeDisclaimerRequestDto;
}

export type RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Args
>;

/**
 * Add a fee disclaimer for a multi family listing
 */
export const useRentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Args) =>
      RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete_Args
>;

/**
 * Deletes a fee disclaimer for a multi family listing
 * @deprecated
 */
export const useRentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete_Args) =>
      RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_delete(args.getParams, httpClient),
  });
};

export interface RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Args {
  postData: UpdateMultifamilyFeeDisclaimerRequestDto;
}

export type RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Args
>;

/**
 * Update a fee disclaimer for a multi family listing
 */
export const useRentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Args) =>
      RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update(args.postData, httpClient),
  });
};
